module.exports = __webpack_public_path__ + "51ed981b770a48c6f4896f4777901bed.png";